import axios from "axios";
import type { AxiosInstance, AxiosRequestConfig } from "axios";
import { SessionHelper } from "../utilities/sessionHelper";
import type { Router } from "vue-router";

let logApi: AxiosInstance;

export default {
  async get(path: string, config?: AxiosRequestConfig) {
    if (!logApi) {
      return Promise.reject("UchiLog Api not initialized yet");
    }
    return await logApi.get(path, config);
  },

  async post(path: string, data?: unknown, config?: AxiosRequestConfig) {
    if (!logApi) {
      return Promise.reject("UchiLog Api not initialized yet");
    }
    return await logApi.post(path, data, config);
  },

  async put(path: string, data?: unknown, config?: AxiosRequestConfig) {
    if (!logApi) {
      return Promise.reject("UchiLog Api not initialized yet");
    }
    return await logApi.put(path, data, config);
  },

  async patch(path: string, data?: unknown, config?: AxiosRequestConfig) {
    if (!logApi) {
      return Promise.reject("UchiLog Api not initialized yet");
    }
    return await logApi.patch(path, data, config);
  },

  async delete(path: string, config?: AxiosRequestConfig) {
    if (!logApi) {
      return Promise.reject("UchiLog Api not initialized yet");
    }
    return await logApi.delete(path, config);
  },

  init(router: Router) {
    logApi = axios.create({
      baseURL: import.meta.env.VITE_APP_UCHI_API_LOG_ENDPOINT
    });

    logApi.interceptors.request.use(config => {
      config.headers["Authorization"] = "Bearer " + SessionHelper.nctSessionToken();
      config.headers["RouteName"] = (router.currentRoute.value as { name?: string }).name ?? "";
      config.headers["x-functions-key"] = import.meta.env.VITE_APP_UCHI_FUNCTION_KEY;
      return config;
    });

    logApi.interceptors.response.use(undefined, error => {
      return Promise.reject(error);
    });
  }
};
